import React from 'react';
import { Link } from 'react-router-dom';

const FinalCTASection = () => {
  return (
    <section className="relative py-16 md:py-20 bg-muted/60">
      <div className="container mx-auto px-6">
        <div className="max-w-xl">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Tecnologia que aproxima, todos os dias.
          </h2>
          <p className="font-body text-lg text-muted-foreground mt-3 mb-6">
            Conheça o CONECTAR e veja como ele pode apoiar sua criança, sua turma ou sua pesquisa.
          </p>
          <Link
            to="/recursos"
            className="inline-flex font-sans font-bold text-[15px] px-7 py-3.5 rounded-full bg-primary text-white hover:bg-primary/90 transition-transform hover:-translate-y-0.5"
          >
            Ver projeto
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
